import {React} from 'react';
import { Button, Typography, useTheme } from '@mui/material';
import { tokens } from 'theme/tokens';

const ButtonSave = ({
  title,
  size='lg',
  variant = 'contained',  
  disabled,
  action,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Button
      disabled={disabled}
      variant={variant}
      onClick={action}
      color='primary'
      sx={{
        width: size === 'lg' ? theme.spacing(12) : theme.spacing(10),
        height: size === 'lg' ? theme.spacing(6) : theme.spacing(4),
        p: 1,
        px: size === 'lg' ? 3 : 2
      }}
    >
      {size === 'lg' ? <Typography variant='body2' sx={{ fontWeight: 500, color: colors.base.white }}>{title}</Typography>:
        <Typography variant='subtitle1' sx={{ color: colors.base.white }}>{title}</Typography>
      }
    </Button>
  );
};

export default ButtonSave;